"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputController = exports.HelpText = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const Animation_1 = require("../../../Animation");
const Tabs_1 = require("../../../Tabs");
const AntiAutoComplete_1 = require("../../AntiAutoComplete");
const Form_1 = require("../../Form");
const FormScope_1 = require("../../FormScope");
const lib_1 = require("../../lib");
const store_1 = require("../../store");
const Wrappers_1 = require("../../Wrappers");
const InputWrapper = app_1.styled.div `
  position: relative;
  width: 100%;
  ${(theme, { $inputType }) => { var _a; return $inputType && ((_a = theme.inputs[$inputType]) === null || _a === void 0 ? void 0 : _a.wrapper); }}
`;
exports.HelpText = app_1.styled.div `
  text-align: left;
  padding-top: 0.25rem;
  font-size: 0.8125rem;
  line-height: 1.1875rem;
  color: ${(theme) => theme.colors.gray};
  margin-bottom: 0.375rem;
`;
const errorStyle = (0, app_1.css) `
  color: ${(theme) => theme.colors.error};
`;
const AnimationWrap = app_1.styled.div `
  min-height: ${(_, { $bottomPadding }) => ($bottomPadding ? '2rem' : 'unset')};
  width: 100%;
`;
const isFilled = (value) => Array.isArray(value)
    ? value.length > 0
    : typeof value === 'string'
        ? !!value.trim()
        : ![null, undefined].includes(value);
const FormInputController = (0, react_1.forwardRef)((_a, ref) => {
    var _b, _c, _d, _e, _f;
    var { containerCss, inputType, className, name: nameProp, label, message, render: Render, success: successOption, defaultValue, validate, serialize, parse, helpText, requiredMessage: requiredMsg, children, gridArea, bottomPadding, noSubmit, removeOnUnmount, keepRegistered, forceError, optional: optionalProp, onChange: onChangeProp } = _a, props = __rest(_a, ["containerCss", "inputType", "className", "name", "label", "message", "render", "success", "defaultValue", "validate", "serialize", "parse", "helpText", "requiredMessage", "children", "gridArea", "bottomPadding", "noSubmit", "removeOnUnmount", "keepRegistered", "forceError", "optional", "onChange"]);
    const scope = (0, FormScope_1.useFormScope)();
    const name = [scope, nameProp].filter(Boolean).join('.');
    const aggregateContext = (0, react_1.useContext)(lib_1.AggregateDataContext);
    const enableIfContext = (0, react_1.useContext)(Wrappers_1.EnableIfContext);
    const optionalIfContext = (0, react_1.useContext)(Wrappers_1.OptionalIfContext);
    const defaultRequiredMessage = (0, app_1.useAppMessage)('requiredFormField');
    const requiredMessage = requiredMsg !== null && requiredMsg !== void 0 ? requiredMsg : defaultRequiredMessage;
    const [success, setSuccess] = (0, react_1.useState)(false);
    const [showError, setShowError] = (0, react_1.useState)(false);
    const defaultValueRef = (0, react_1.useRef)(defaultValue);
    const registered = (0, react_1.useRef)(false);
    const onChange = onChangeProp !== null && onChangeProp !== void 0 ? onChangeProp : ((v) => v);
    const changeRef = (0, react_1.useRef)(onChange);
    changeRef.current = onChange;
    const pageId = (0, react_1.useContext)(lib_1.FormPageContext);
    const { tab, setTab } = (_b = (0, react_1.useContext)(Tabs_1.TabsContext)) !== null && _b !== void 0 ? _b : {};
    const optional = (_c = optionalIfContext === null || optionalIfContext === void 0 ? void 0 : optionalIfContext.optional) !== null && _c !== void 0 ? _c : optionalProp;
    const validator = (0, react_1.useMemo)(() => createValidator(validate, { optional, requiredMessage }), [validate, optional, requiredMessage]);
    const dispatch = (0, react_1.useContext)(lib_1.InternalFormDispatchContext);
    const id = (0, react_1.useContext)(lib_1.InternalFormIdContext);
    const [{ submitting, success: formSuccess }] = (0, store_1.getInternalFormStore)(id)('submitting', 'success');
    const input = (_d = (0, store_1.useFormInputController)(name)) !== null && _d !== void 0 ? _d : (0, lib_1.defaultController)(defaultValue);
    const inputStage = (0, lib_1.getInputStage)(input);
    const isDuplicate = (0, react_1.useRef)(inputStage === 'REGISTERED');
    const aggregator = (0, react_1.useContext)(lib_1.AggregateDataContext);
    (0, react_1.useEffect)(() => {
        if (submitting) {
            setShowError(true);
        }
        if (formSuccess) {
            setShowError(false);
        }
    }, [submitting, formSuccess]);
    (0, react_1.useEffect)(() => {
        var _a;
        dispatch('REGISTER_INPUT', {
            name,
            value: defaultValueRef.current,
            validate: validator,
            serialize,
            parse,
            pageId,
            noSubmit,
            aggregator: (_a = aggregator === null || aggregator === void 0 ? void 0 : aggregator.name) !== null && _a !== void 0 ? _a : null,
            showTab: tab && setTab ? () => setTab(tab) : undefined,
        });
        registered.current = true;
    }, [
        name,
        validator,
        serialize,
        parse,
        pageId,
        aggregator,
        tab,
        setTab,
        dispatch,
        noSubmit,
    ]);
    (0, react_1.useEffect)(() => {
        if (registered.current) {
            dispatch('UPDATE_INPUT', {
                name,
                validate: validator,
            });
        }
    }, [dispatch, name, validator]);
    const cleanup = (0, react_1.useRef)(() => null);
    (0, react_1.useEffect)(() => () => cleanup.current(), []);
    cleanup.current = () => {
        if (keepRegistered ||
            (aggregateContext === null || aggregateContext === void 0 ? void 0 : aggregateContext.keepRegistered) ||
            isDuplicate.current) {
            return;
        }
        dispatch(removeOnUnmount ? 'REMOVE_INPUT' : 'UNREGISTER_INPUT', name);
        setShowError(false);
    };
    const { value: controllerValue, setValue, error, setError } = input;
    const handleChange = (0, react_1.useCallback)((v) => {
        setValue((current) => {
            var _a;
            const newV = typeof v === 'function' ? v(current) : v;
            return (_a = changeRef.current(newV, current)) !== null && _a !== void 0 ? _a : newV;
        });
    }, [setValue]);
    const value = inputStage === 'NOT_REGISTERED'
        ? (_e = parse === null || parse === void 0 ? void 0 : parse(controllerValue)) !== null && _e !== void 0 ? _e : controllerValue
        : controllerValue;
    const { onBlur, onFocus, autoComplete } = props;
    (0, react_1.useEffect)(() => {
        const err = validator === null || validator === void 0 ? void 0 : validator(value);
        setSuccess(isFilled(value) && successOption === 'instant' && !err);
        setError(err);
    }, [value, validator]);
    const handleBlur = (0, react_1.useCallback)((v) => {
        const err = validator === null || validator === void 0 ? void 0 : validator(v);
        setSuccess(isFilled(v) && !!successOption && !err);
        setError(err);
        setShowError(true);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(v);
    }, [validator, setError, onBlur, successOption]);
    const handleFocus = (0, react_1.useCallback)((v) => {
        const newError = validator ? validator(v) : undefined;
        setError(newError);
        setShowError(false);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(v);
    }, [validator, setError, onFocus]);
    const hasError = Boolean(forceError || (showError && !formSuccess && error !== undefined));
    const visibleError = hasError && Boolean(error);
    const disabled = (_f = enableIfContext === null || enableIfContext === void 0 ? void 0 : enableIfContext.disabled) !== null && _f !== void 0 ? _f : props.disabled;
    return (Render && ((0, jsx_runtime_1.jsxs)(InputWrapper, Object.assign({ css: containerCss, style: Object.assign({}, (gridArea ? { gridArea } : {})) }, { children: [(0, jsx_runtime_1.jsxs)(InputWrapper, Object.assign({ "$inputType": inputType }, { children: [props.type === 'password' &&
                        /(false|off)/u.test(autoComplete !== null && autoComplete !== void 0 ? autoComplete : '') && ((0, jsx_runtime_1.jsx)(AntiAutoComplete_1.AntiAutoComplete, { form: id })), (0, jsx_runtime_1.jsx)(Render, Object.assign({}, props, { optional, hasError, label, value, ref, disabled, message }, { form: id, success: !error && success, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, className: className })), children] })), (0, jsx_runtime_1.jsx)(AnimationWrap, Object.assign({ "$bottomPadding": bottomPadding }, { children: (0, jsx_runtime_1.jsx)(Animation_1.Animation, Object.assign({ auto: "height" }, { children: (visibleError || helpText) && ((0, jsx_runtime_1.jsx)(exports.HelpText, Object.assign({ css: (0, app_1.css) `
                    ${visibleError && errorStyle}
                  ` }, { children: hasError ? error : helpText }))) })) }))] }))));
});
function validatorResolver(validate) {
    return (value) => {
        var _a;
        if (typeof validate === 'function') {
            return validate(value);
        }
        if (Array.isArray(validate)) {
            return (_a = validate.find(({ validator }) => !validator(value))) === null || _a === void 0 ? void 0 : _a.errorMessage;
        }
        if (validate) {
            const hasError = !validate.validator(value);
            return hasError ? validate.errorMessage : undefined;
        }
    };
}
function createValidator(validate, { optional, requiredMessage }) {
    const validator = validatorResolver(validate);
    return optional
        ? validate &&
            ((v) => {
                if (Array.isArray(v) && v.length === 0) {
                    return;
                }
                switch (typeof v) {
                    case 'string': {
                        return v.length === 0 ? undefined : validator(v);
                    }
                    case 'number': {
                        return Number.isNaN(v) ? undefined : validator(v);
                    }
                    default: {
                        return v ? validator(v) : undefined;
                    }
                }
            })
        : (v) => {
            if (Array.isArray(v) && v.length === 0) {
                return requiredMessage;
            }
            const err = validator === null || validator === void 0 ? void 0 : validator(v);
            switch (typeof v) {
                case 'string': {
                    return v.length === 0 ? requiredMessage : err;
                }
                case 'number': {
                    return Number.isNaN(v) ? requiredMessage : err;
                }
                default: {
                    return v ? err : err !== null && err !== void 0 ? err : requiredMessage;
                }
            }
        };
}
exports.InputController = (0, react_1.forwardRef)((_a, ref) => {
    var { onSubmit, standalone = !!onSubmit } = _a, props = __rest(_a, ["onSubmit", "standalone"]);
    const formContext = (0, react_1.useContext)(lib_1.InternalFormContext);
    const isStandalone = standalone || !formContext;
    const scope = (0, FormScope_1.useFormScope)();
    const name = [scope, props.name].filter(Boolean).join('.');
    return isStandalone ? ((0, jsx_runtime_1.jsx)(Form_1.Form, Object.assign({ onSubmit: (data, allData) => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(data[name], allData));
            return result !== null && result !== void 0 ? result : Form_1.SubmitState.DO_NOT_CLEAR;
        }), contextOnly: true }, { children: (0, jsx_runtime_1.jsx)(FormInputController, Object.assign({}, props, { ref: ref })) }))) : ((0, jsx_runtime_1.jsx)(FormInputController, Object.assign({}, props, { ref: ref })));
});
